export { default } from './ShelfPrivacyAlert';



// WEBPACK FOOTER //
// ./app/components/shared/UGC/ShelfPrivacyAlert/index.js